import * as React from "react";
import { forwardRef } from "react";
const SvgGaugeArrowDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 19, height: 44, viewBox: "0 0 19 44", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.5 39.5L1.70577 10.25L17.2942 10.25L9.5 39.5Z", fill: "black", stroke: "black", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M13.4291 11.75L9.5 28.1964L5.57089 11.75H13.4291Z", fill: "black", stroke: "white", strokeWidth: 2 }));
const ForwardRef = forwardRef(SvgGaugeArrowDown);
export { ForwardRef as ReactComponent };
